<template>
  <v-navigation-drawer absolute app dark class="grad" clipped floating v-model="sideNav" temporary>
    <v-list-item two-line>
      <v-list-item-avatar color="white" v-if="userIsAuthenticated && user.photoUrl">
        <v-img
          alt="avatar"
          :lazy-src="user.photoUrl"
          :src="user.photoUrl+ '?height=500'"
          v-if="user.photoUrl"
        />
      </v-list-item-avatar>

      <v-list-item-title class="title">WELCOME</v-list-item-title>
    </v-list-item>

    <v-divider class="mx-3 mb-3" />

    <v-list nav>
      <div />

      <span v-for="(link, i) in links" :key="i">
        <v-list-item :to="link.to" active-class="second-grad white--text">
          <v-list-item-action>
            <v-icon>{{ link.icon }}</v-icon>
          </v-list-item-action>

          <v-list-item-title v-text="link.text" />
        </v-list-item>
      </span>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters({ sideNav: "sideNav", isBusines: "business", user: "user" }),
    userIsAuthenticated() {
      return this.user !== null && this.user !== undefined;
    }
  },
  data: () => ({
    links: [
      {
        to: "/",
        icon: "fas fa-home",
        text: "Home"
      },
      {
        to: "/profile",
        icon: "mdi-account-circle",
        text: "Profile"
      },
      {
        to: "/gym",
        icon: "mdi-dumbbell",
        text: "Gym"
      },
      {
        to: "/trainer",
        icon: "mdi-clipboard-outline",
        text: "Coach"
      },
      {
        to: "/kine",
        icon: "mdi-walk",
        text: "Kiné"
      },
      {
        to: "/nutrition",
        icon: "mdi-carrot",
        text: "Nutritionniste"
      }
    ]
  })
};
</script>

<style>
.grad {
  color: white;
  background: rgb(18, 25, 40);
  background: linear-gradient(
    180deg,
    rgba(18, 25, 40, 1) 0%,
    rgba(109, 116, 135, 0.9976190305223652) 58%,
    rgba(18, 25, 40, 1) 100%
  );
}
.second-grad {
  background: rgb(0, 198, 255);
  background: radial-gradient(
    circle,
    rgba(0, 198, 255, 1) 0%,
    rgba(0, 114, 255, 1) 100%
  );
}
</style>
